(function () {
  const gallerySelector = '[data-stacked-mobile-gallery]';

  function updateFeaturedItem(gallery, featuredMediaId) {
    if (!gallery || !featuredMediaId) return;

    const grid = gallery.querySelector('[data-stacked-gallery-grid]');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('[data-media-id]'));
    const nextFeaturedItem = items.find((item) => item.dataset.mediaId === String(featuredMediaId));
    if (!nextFeaturedItem) return;

    items.forEach((item) => item.classList.remove('main-product-stacked-mobile-gallery__item--featured'));
    nextFeaturedItem.classList.add('main-product-stacked-mobile-gallery__item--featured');
    grid.prepend(nextFeaturedItem);
  }

  function syncFromVariantChange(event) {
    const sectionId = event?.data?.sectionId;
    const featuredMediaId = event?.data?.variant?.featured_media?.id;
    if (!sectionId || !featuredMediaId) return;

    const gallery = document.querySelector(`${gallerySelector}[data-section-id="${sectionId}"]`);
    updateFeaturedItem(gallery, featuredMediaId);
  }

  function initStackedMobileGallery() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    if (window.__stackedMobileGallerySubscribed) return;
    window.__stackedMobileGallerySubscribed = true;

    subscribe(PUB_SUB_EVENTS.variantChange, syncFromVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStackedMobileGallery);
  } else {
    initStackedMobileGallery();
  }
})();
